import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type { FormItemProps } from "@gatsby-plugin-generic-page/components/Formily/FormItem"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import { Text } from "@ionos-web-design-system/react"
import Tooltip from "~/components/Tooltip"
import { cn } from "~/helpers/cn"

export const FormItemLayout = ({
  label,
  description,
  tooltip,
  required,
  children,
}: FormItemProps) => {
  const requiredJSX = required ? (
    <Text asChild variant="bodyXs" color="accent" className="pr-1">
      <span>*</span>
    </Text>
  ) : null

  const labelJSX = tooltip ? (
    <PushOrg bottomSpace={description ? 0 : 1}>
      <FlexContainerOrg>
        {requiredJSX}
        <Tooltip
          labelText={label}
          labelTypography="small2"
          labelEmphasis="high"
        >
          {tooltip}
        </Tooltip>
      </FlexContainerOrg>
    </PushOrg>
  ) : (
    <Text
      variant="bodyXs"
      className={cn(description ? "mb-0" : "mb-1", "text-disabled")}
    >
      {requiredJSX}
      {label}
    </Text>
  )

  const descriptionJSX = description ? (
    <PushOrg bottomSpace={1}>
      <MarkdownText
        typography={{ bold: "tiny3", default: "tiny1" }}
        emphasis="low"
      >
        {description}
      </MarkdownText>
    </PushOrg>
  ) : null

  return (
    <PushOrg bottomSpace={2} hasNoReset>
      {label ? labelJSX : null}

      {label && description ? descriptionJSX : null}

      {children}
    </PushOrg>
  )
}
